import { Z_INDEX_COPILOT_SIDEBAR } from '../../../constants/z_index';
const COPILOT_SIDEBAR_WIDTH = '400';
export const getStyle = () => ({
  borderTop: '1px solid transparent',
  borderLeft: '1px solid transparent',
  borderBottom: '1px solid transparent',
  borderRight: 'none',
  background: 'linear-gradient(#ffffff,#ffffff,#ffffff) padding-box,linear-gradient(#ff4800,#fc0849,#d20688) border-box',
  boxShadow: 'none',
  borderRadius: '16px 0px 0px 16px',
  height: `calc(100vh - var(--global-nav-height, 44px))`,
  // GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT: https://git.hubteam.com/HubSpot/Navigation/blob/master/nav-meta/static/js/constants.ts#L7
  width: `${COPILOT_SIDEBAR_WIDTH}px`,
  position: 'fixed',
  top: 'var(--global-nav-height, 44px)',
  // GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT: https://git.hubteam.com/HubSpot/Navigation/blob/master/nav-meta/static/js/constants.ts#L7
  right: 0,
  zIndex: Z_INDEX_COPILOT_SIDEBAR
});